module.exports = __webpack_public_path__ + "static/media/Delete.90c7de77.svg";